import { render, staticRenderFns } from "./InputAnggota.vue?vue&type=template&id=52828184&"
import script from "./InputAnggota.vue?vue&type=script&lang=js&"
export * from "./InputAnggota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports